/**
 * Combine all reducers in this file and export the combined reducers.
 */

import {combineReducers} from 'redux-immutable';
import {connectRouter} from 'connected-react-router/immutable';
import history from '../../utils/history';
import languageProviderReducer from "../../components/LanguageProvider/reducer";
import redirectStateReducer from "../global/redirect/reducer";

/**
 * Merges the main reducer with the router state and dynamically injected reducers
 */
export default function createReducer(injectedReducers = {}) {
    return combineReducers({
        router: connectRouter(history),
        language: languageProviderReducer,
        redirect: redirectStateReducer,
        ...injectedReducers,
    });
}



// WEBPACK FOOTER //
// ./src/redux/config/reducers.js